<div class="kyb-reevaluation-started-dialog">
  <mat-dialog-content>
    <div class="badge">
      <span class="mdi mdi-sync"></span>
    </div>
    <div class="title">Re-evaluation started</div>
    <p class="lead">FrankieOne is re-evaluating this entity. This can take a few minutes.</p>
    <p class="note">
      The current risk score and rating stay on screen until the new ones arrive. Reload the page later to see them.
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button color="primary" (click)="close()">Got it</button>
  </mat-dialog-actions>
</div>
